import { mapState, mapMutations } from "vuex";
import moment from "moment";

import ModalCreateProvisionService from "../../../components/Modals/ModalCreateProvisionService.vue";

import InputSelect from "../../../components/UI/CustomInputs/InputSelect.vue";
import Input from "../../../components/UI/CustomInputs/Input.vue";
import InputMoney from "../../../components/UI/CustomInputs/InputMoney.vue";
import InputQuant from "../../../components/UI/CustomInputs/InputQuant.vue";
import InputPercentage from "../../../components/UI/CustomInputs/InputPercentage.vue";
import Tabs from "../../../components/UI/Tabs/Tab.vue"

import ServiceCustomer from "../../../services/serviceCustomer";
import ServiceProducts from "../../../services/serviceProducts";
import ServiceProductionOrderItem from "../../../services/serviceProductionOrderItem";
import ServiceProductionOrder from "../../../services/serviceProductionOrder";
import ServiceToBeProvided from "../../../services/serviceToBeProvided";

import { ValidadeProductionOrderItem } from "../../../validators/productionOrderItem";

import { maskCurrency, maskPercentage, } from "../../../utils/maskMoney";
import { removeReference } from "../../../utils/removeReference";
import { HandleErrors } from "../../../utils/handleErrors";

export const mixinServiceItem = {
  props: {
    productionOrder: {
      type: Object
    }
  },
  components: {
    InputSelect,
    Input,
    InputMoney,
    InputQuant,
    InputPercentage,
    ModalCreateProvisionService,
    Tabs,
  },
  data() {
    return {
      blocked: false,
      comissao: "",
      productUnitaryValue: "",
      fields: ["Produto", "Quantidade", "Valor"],
      totalParcelas: 1,
      intervaloDias: 0,
      discountToAllItems: false,
      discountIsCheked: false,
      productionOrderIsCanceled: false,
      situationSelected: null,
      createdNewCustomer: false,
      createdNewEmployee: null,
      createdNewProducts: null,
      idProductFromSearch: "",
      listServices: [],
      lineServiceItem: {
        id: "",
        idOrdemProducao: "",
        idFornecedor: "",
        idServico: "",
        idProduto: "",
        quantidade: 1,
        altura: 0,
        largura: 0,
        metragem: 0,
        valorUnitario: 0,
        valorTotal: 0,
        desconto: 0,
        dadosAdicionais: "",
        porcentagemPerda: 0,
        idCor: "",
        idAmbiente: "",
        linear: false,
        tipoPreco: "P1",
        tipoItem: "servico",
        estoque: 0,
        tipoDesconto: "valor_monetario"
      },
      toggleToUpdate: false,
      productLoading: false,
      tableServices: [],
      maskPercentage: maskPercentage,
      maskCurrency: maskCurrency,
      isLoadingToDelete: false,
    };
  },
  methods: {
    ...mapMutations([]),
    async handleAddMoreItems() {
      if (!this.productionOrder.idCliente) {
        return this.$toast.open({
          message: "(Cliente) deve ser selecionado para prosseguir",
          type: "info",
        });
      }

      await this.saveProdutionOrder()

      this.lineServiceItem.id
        ? await this.updateProductItem()
        : await this.saveProductionItem();

      this.handleCalculateTotalsValues();
    },

    async saveProductionItem() {
      try {
        this.lineServiceItem.idOrdemProducao = this.productionOrder.id;

        if (!this.validadeProductOfProductionOrder(this.lineServiceItem)) return;

        await ServiceProductionOrderItem.save({ ...this.lineServiceItem });
        await this.findTableItemsOfProducionOrder();
        this.clearLineItem();

        return this.$toast.open({
          message: "Produto adicionado",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : typeError?.message ? typeError?.message : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async updateProductItem() {
      try {
        this.lineServiceItem.idOrdemProducao = this.productionOrder.id;

        if (!this.validadeProductOfProductionOrder(this.lineServiceItem)) return;

        await ServiceProductionOrderItem.update(this.lineServiceItem.id, this.lineServiceItem);
        await this.findTableItemsOfProducionOrder();
        this.clearLineItem();

        return this.$toast.open({
          message: "Produto atualizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
            "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async saveProdutionOrder() {
      try {
        this.productLoading = true;
        if (this.productionOrder.id) return;

        const result = await ServiceProductionOrder.save(this.productionOrder);

        this.$emit('productionOrderIdAndNumber', { id: result.id, number: result.number });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao salvar",
          type: "info",
        });

        this.productLoading = false;
      }
    },

    async updateProductionOrder() {
      await ServiceProductionOrder.update(this.productionOrder);
    },

    async removeItens(id) {
      try {
        this.isLoadingToDelete = true
        await ServiceProductionOrderItem.delete(id);
        await this.findTableItemsOfProducionOrder();

        this.handleCalculateTotalsValues();
        return this.$toast.open({
          message: "Produto removido",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message}` ||
            "Ocorreu um erro ao remover o produto!",
          type: "info",
        });
      } finally {
        this.isLoadingToDelete = false
      }
    },

    async alterDiscountIsCheked() {
      this.discountIsCheked = !this.discountIsCheked;

      if (this.discountIsCheked) {
        this.lineServiceItem.tipoDesconto = "porcentagem";
        this.$refs.enableLabelApplyAll.style.display = "block";
      } else {
        this.lineServiceItem.tipoDesconto = "valor_monetario";
        this.$refs.enableLabelApplyAll.style.display = "none";
        this.discountToAllItems = false;
      }

      if (this.productionOrder.id) await this.updateProductionOrder();

      this.handleCalculateTotalsValues();
      this.handleCalculateTotal();
    },

    async getProductById(idProduct) {
      const data = await ServiceProducts.getProductById(idProduct);
      return data;
    },

    async handleDuplicate(itemsOfProductionOrder) {
      try {
        const newProd = removeReference(itemsOfProductionOrder);
        newProd.id = "";
        newProd.createdAt = null

        await ServiceProductionOrderItem.save(newProd);
        await this.findTableItemsOfProducionOrder();
        this.handleCalculateTotalsValues()

        this.$toast.open({
          message: "Item Clonado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao clonar o item",
          type: "info",
        });
      }
    },

    async findTableItemsOfProducionOrder() {
      const result = await ServiceProductionOrderItem.findByIdProductionOrderPerTypeItem(this.productionOrder.id, 'servico');

      this.tableServices = result || [];

      if (this.tableServices.length) {
        const isCheckedDicount = this.tableServices.find(item => item.tipoDesconto)

        if (isCheckedDicount.tipoDesconto === "porcentagem") {
          this.discountIsCheked = true;

          this.$refs.enableLabelApplyAll.style.display = "block";
        }
      }

      this.$emit('productionOrderItems', this.tableServices)
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async fillCustomerComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceCustomer.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },

    async fillServiceComboBox() {
      this.listServices = await ServiceToBeProvided.getServicesFromSelectBox();
    },

    validadeProductOfProductionOrder(prod) {
      const isNotValid = ValidadeProductionOrderItem(prod);

      if (isNotValid && Object.keys(isNotValid).length) {
        this.$toast.open({
          message: isNotValid.message,
          type: "info",
        });

        return false;
      }

      return true;
    },

    handleCalculateTotalInTable(prod) {
      let newTotalValue = 0;

      if (prod.tipoDesconto === "porcentagem") {
        const result = (prod.valorTotal * (prod.desconto / 100)).toFixed(2);

        newTotalValue = parseFloat(prod.valorTotal - result);
      } else {
        newTotalValue = prod.valorTotal - prod.desconto;
      }

      return maskCurrency(newTotalValue);
    },

    handleSelectService(idServico){
      const result = this.listServices.find(servico => servico.id === idServico)

      if(result) {
        this.lineServiceItem.valorUnitario = result.valor
        this.$refs.refVlUnit.valueInput = result.valor
      }
    },

    assignProduct(orderItem) {
      this.lineServiceItem = orderItem;

      this.$refs.refQtd.valueInput = orderItem.quantidade;
      this.$refs.refVlUnit.valueInput = orderItem.valorUnitario;
      this.$refs.valorTotal.valueInput = orderItem.valorTotal;
      this.$refs.discount.valueInput = orderItem.desconto;
      this.$refs.dadosAdicionais.valueInput = orderItem.dadosAdicionais;
      this.$refs.servicos.valueItems = orderItem.idServico

      this.handleCalculateTotal();
    },

    clearLineItem() {
      this.lineServiceItem = {
        ...this.lineServiceItem,
        id: "",
        idOrdemProducao: "",
        idFornecedor: "",
        quantidade: 1,
        dadosAdicionais: "",
        estoque: 0,
      };

      if (!this.keepItems) {
        this.lineServiceItem = {
          ...this.lineServiceItem,
          idServico: "",
          idProduto: "",
          altura: 0,
          largura: 0,
          metragem: 0,
          valorUnitario: 0,
          valorTotal: 0,
          porcentagemPerda: 0,
          idCor: "",
          idAmbiente: "",
          linear: false,
          tipoPreco: "P1",
        }

        if (!this.discountToAllItems) {
          this.lineServiceItem.desconto = 0;
          this.$refs.discount.valueInput = 0;
        }

        let discountValue = 0;
        if (this.lineServiceItem.tipoDesconto === "porcentagem") {
          const result = (
            this.lineServiceItem.valorTotal *
            (this.lineServiceItem.desconto / 100)
          ).toFixed(2);

          discountValue = parseFloat(result);
        } else {
          discountValue = this.lineServiceItem.desconto;
        }

        this.$refs.valorTotal.valueInput = this.lineServiceItem.valorTotal - discountValue;
        this.$refs.refVlUnit.valueInput = this.lineServiceItem.valorUnitario;
      } else {
        this.$refs.valorTotal.valueInput = this.lineServiceItem.valorTotal;
      }

      this.$refs.servicos.valueItems = ""
      this.$refs.refQtd.valueInput = 1;
      this.$refs.dadosAdicionais.valueInput = "";
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleCalculateTotal() {
      const amount = Number(this.lineServiceItem.quantidade);
      const unitaryValue = this.lineServiceItem.valorUnitario;
      const totalValue = amount * unitaryValue;

      if (!this.$refs.valorTotal) return;

      this.lineServiceItem.valorTotal = totalValue;

      let discountValue = 0;

      if (this.lineServiceItem.tipoDesconto === "porcentagem") {
        const result = (
          this.lineServiceItem.valorTotal *
          (this.lineServiceItem.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result);
      } else {
        discountValue = this.lineServiceItem.desconto;
      }

      this.$refs.valorTotal.valueInput = totalValue - discountValue;
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    clearAllRefs() {
      this.$refs.valorTotal.valueInput = 0;
      this.$refs.refVlUnit.valueInput = 0;
    },

    editProductsOfProductionOrder(prod) {
      try {
        const newProd = removeReference(prod);
        this.assignProduct(newProd);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao editar o produto",
          type: "info",
        });
      }
    },

    assignTotalItensValues() {
      const valorTotal = this.tableServices.reduce((oldValue, product) => {
        // const valorCorrigido = Math.floor(parseFloat(product.valorTotal) * 100) / 100;
        return oldValue + +(+product.valorTotal.toFixed(2));
      }, 0
      );

      this.$emit('totalOfItensService', valorTotal)
    },

    assignTotalDiscount() {
      let totalOfDiscount = 0

      if (this.discountIsCheked) {
        totalOfDiscount = this.calculateTotalDiscount();
      } else {
        totalOfDiscount = this.calculateTotalDiscountWithMonetaryValue();
      }

      this.$emit('discountOfItensService', totalOfDiscount)
    },

    calculateTotalDiscount() {
      const discounts = this.tableServices.map((prod) => {
        const desc = prod.desconto;
        const totalValue = prod.valorTotal;

        return +((totalValue * desc) / 100).toFixed(2);
      });

      const totalValueWithDiscount = discounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalValueWithDiscount
    },

    calculateTotalDiscountWithMonetaryValue() {
      const monetaryDiscounts = this.tableServices.map(
        (prod) => {
          if (prod.desconto) {
            const desc = prod.desconto;

            return desc;
          }

          return 0;
        }
      );

      const totalMonetaryWithDiscount = monetaryDiscounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalMonetaryWithDiscount
    },

    alterAllChecksDiscount() {
      if (this.discountToAllItems) {
        this.$refs.typeDiscount.checked = true;

        this.assignTotalItensValues();
        this.assignTotalDiscount();
      }
    },

    clearAll() {
      this.clearLineItem()
      this.tableServices = []
      this.assignTotalDiscount()
      this.assignTotalItensValues()
    },

    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },

    handleCalculateTotalsValues() {
      this.assignTotalItensValues();
      this.assignTotalDiscount();
    },
  },
  async mounted() {
    this.fillServiceComboBox()

    await this.$nextTick()

    if (this.productionOrder.id) {
      await this.findTableItemsOfProducionOrder()
      this.handleCalculateTotalsValues()
    }
  },
  filters: {
    moment(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
  computed: {
    ...mapState({
      dataConfig: (state) => state.dataConfig,
    }),

    lossPercentage() {
      if (this.dataConfig) {
        return Number(this.dataConfig.venda_mtq.porcentagem_perda)
      }

      return 2
    },
    keepItems() {
      // Descomentar caso o cliente precise, pois como é uma Ordem de produção não sei se faz sentido deixar
      // if (Object.keys(this.dataConfig).length) {
      //   return Number(this.dataConfig?.venda_mtq?.manter_itens)
      // }

      return false;
    },
    validatorDesc() {
      let existsDiscount = false;

      if (this.tableServices.length) {
        for (const product of this.tableServices) {
          if (product.desconto) {
            existsDiscount = true;
            break;
          }
        }
      }

      return existsDiscount;
    },
    isBlockStock() {
      return this.dataConfig?.venda?.bloqueio_estoque
    },
    isClear() {
      return this.productionOrder.id
    }
  },
  watch: {
    isClear() {
      if (!this.isClear) this.clearAll();
    }
  },
  beforeDestroy() {
  }
}
